﻿export const Field = field => {
    const visible = 'visible';

    const formGroup = field.closest('.js-field-validate , [data-validation-role="js-field-validate"]');
    const fieldAsterik = field.parentNode.querySelector('.form-field-group__asterik');
    const errorMessage = formGroup && formGroup.querySelector('.js-field-validate--error');

    if (!errorMessage) {
        console.warn("Error message missing for", field);
    }

    return {
        element: field,
        formGroup: formGroup,
        showError() {
            if (field.type === "checkbox" || field.type === "radio") {
                this.toggleForGroup(true);
            } else {
                field.setAttribute('aria-invalid', 'true');
            }
            if (errorMessage) {
                const adjacentInput = errorMessage.previousElementSibling;
                const inputName = adjacentInput.getAttribute('name');
                const errorId = `${inputName}-error`;
                errorMessage.classList.add(visible);
                adjacentInput.setAttribute('aria-describedby', errorId);
                errorMessage.setAttribute('id', errorId);
            }
        },
        hideError() {
            if (field.type === "checkbox" || field.type === "radio") {
                this.toggleForGroup(false);
            } else {
                field.removeAttribute('aria-invalid');
            }
            if (errorMessage) {
                const adjacentInput = errorMessage.previousElementSibling;
                const inputName = adjacentInput.getAttribute('name');
                const errorId = `${inputName}-error`;
                errorMessage.classList.remove(visible);
                adjacentInput.removeAttribute('aria-describedby', errorId);
                errorMessage.removeAttribute('id', errorId);
            }
        },
        setEagerValidation() {
            field.setAttribute('data-eager-validate', '');
        },
        setRequired() {
            field.setAttribute('required', 'required');
            fieldAsterik && fieldAsterik.classList.remove('hide');
        },
        removeRequired() {
            field.removeAttribute('required');
            fieldAsterik && fieldAsterik.classList.add('hide');
        },
        isReactiveValidationEnabled() {
            return field.hasAttribute('data-reactive-validate');
        },
        isEagerValidationEnabled() {
            return field.hasAttribute('data-eager-validate');
        },
        focus() {
            field.focus();
        },
        toggleForGroup(toggleOn) {

            var nodeList = document.getElementsByName(field.name);

            if (nodeList && nodeList.length > 0) {
                if (toggleOn) {
                    [...nodeList].map(x => x.setAttribute('aria-invalid', 'true'));
                } else {
                    [...nodeList].map(x => x.removeAttribute('aria-invalid'));

                }
            }
        }
    };
}